export default "__VITE_ASSET__DnsAQeDD__"